@if (showModal) {
  <kehe-phoenix-modal
    name="createSubscriptionModal"
    modalTitle="Subscribe to Reports"
    [show]="showModal"
    (modalEvent)="handleModalEvent($event)"
    size="md"
  >
    <div body class="modal-body">
      <div class="container">
        <div class="row mb-3">
          <div class="col-sm-9" id="report-type-col">
            <label>Report Type</label>
            <kendo-dropdownlist
              [data]="reportOptions"
              valueField="value"
              textField="label"
              [(ngModel)]="selectedReport"
              (valueChange)="onReportChanged()"
            ></kendo-dropdownlist>
          </div>
        </div>
        @switch (selectedReport?.value) {
          @case (reportName.BrandItemLocation) {
            <app-supplier-dc-brand-filter
              #subscriptionFilter
              (filterChanged)="onFilterChanged($event)"
            >
            </app-supplier-dc-brand-filter>
          }
          @case (reportName.InventoryStockStatus) {
            <app-inventory-stock-status-filter
              #subscriptionFilter
              (filterChanged)="onFilterChanged($event)"
            >
            </app-inventory-stock-status-filter>
          }
          @case (reportName.Item360RecapHd) {
            <app-item-recap-hd-filter
              #subscriptionFilter
              (filterChanged)="onFilterChanged($event)"
            >
            </app-item-recap-hd-filter>
          }
          @case (reportName.EnterpriseSupplierChainSalesbyBrand) {
            <app-chain-sales-brand-filter
              #subscriptionFilter
              (filterChanged)="onFilterChanged($event)"
            >
            </app-chain-sales-brand-filter>
          }
          @case (reportName.KeheFullPodVendor) {
            <app-kehe-full-pod-filter
              #subscriptionFilter
              (filterChanged)="onFilterChanged($event)"
            >
            </app-kehe-full-pod-filter>
          }
          @case (reportName.ChainsAndStoresThatOrderedAnItem) {
            <app-chains-stores-item-filter
              #subscriptionFilter
              (filterChanged)="onFilterChanged($event)"
            >
            </app-chains-stores-item-filter>
          }
          @case (reportName.InboundFillRate) {
            <app-inbound-fill-rate-filter
              #subscriptionFilter
              (filterChanged)="onFilterChanged($event)"
            >
            </app-inbound-fill-rate-filter>
          }
          @case (reportName.InventoryAtRisk) {
            <app-inventory-at-risk-filter
              #subscriptionFilter
              (filterChanged)="onFilterChanged($event)"
            >
            </app-inventory-at-risk-filter>
          }
        }
        <hr />
        <div class="row">
          <div class="col-sm-6">
            <h4>Weekly Recurrence</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="select-days-label">Select Day</div>
            <div class="d-sm-inline-flex">
              @for (day of dayOptions; track day) {
                <input
                  #dayOfTheWeek
                  type="radio"
                  kendoRadioButton
                  [value]="day.id"
                  [(ngModel)]="selectedDay"
                  (change)="daySelected()"
                />
                <kendo-label
                  class="k-radio-label"
                  [for]="dayOfTheWeek"
                  [text]="day.text"
                ></kendo-label>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    <div footer class="footer">
      <kehe-phoenix-button
        class="cancel-button"
        name="cancel"
        classAttr="btn-link btn-medium"
        (click)="cancelClicked()"
      >
        Cancel
      </kehe-phoenix-button>
      <kehe-phoenix-button
        name="submitSubscription"
        classAttr="btn-primary btn-medium"
        [disabled]="!isFormValid()"
        (click)="onSubmit()"
        [spinner]="createSubscriptionLoading$ | async"
      >
        Subscribe
      </kehe-phoenix-button>
    </div>
  </kehe-phoenix-modal>
}
